import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

interface DifficultyLevelItem {
  id: number;
  name: string;
}


@Component({
  selector: 'app-difficulty-level',
  standalone: false,
  templateUrl: './difficulty-level.html',
  styleUrl: './difficulty-level.scss',
})
export class DifficultyLevel implements OnInit{
  pageTitle = 'Difficulty Levels';

  pageSubtitle =
    'View, manage, and organize all course difficulty levels in one place.';

  searchTerm = '';

  page = 1;
  pageSize = 10;

  difficultyLevels: DifficultyLevelItem[] = [
    {
      id: 1,
      name: 'Higher',
    },
    {
      id: 2,
      name: 'Medium',
    },
  ];

  filteredDifficultyLevels:
    DifficultyLevelItem[] = [];

  constructor(
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.applyFilters();
  }

  get paginatedDifficultyLevels():
    DifficultyLevelItem[] {
    const startIndex =
      (this.page - 1) * this.pageSize;

    const endIndex =
      startIndex + this.pageSize;

    return this.filteredDifficultyLevels.slice(
      startIndex,
      endIndex
    );
  }

  get startItem(): number {
    if (
      this.filteredDifficultyLevels.length ===
      0
    ) {
      return 0;
    }

    return (
      (this.page - 1) * this.pageSize + 1
    );
  }

  get endItem(): number {
    return Math.min(
      this.page * this.pageSize,
      this.filteredDifficultyLevels.length
    );
  }

  onSearchChange(): void {
    this.page = 1;
    this.applyFilters();
  }

  onPageSizeChange(event: Event): void {
    const selectElement =
      event.target as HTMLSelectElement;

    this.pageSize = Number(
      selectElement.value
    );

    this.page = 1;
  }

  applyFilters(): void {
    const normalizedSearch =
      this.searchTerm
        .trim()
        .toLowerCase();

    this.filteredDifficultyLevels =
      this.difficultyLevels.filter(
        (difficultyLevel) =>
          difficultyLevel.name
            .toLowerCase()
            .includes(normalizedSearch)
      );

    const lastAvailablePage = Math.max(
      1,
      Math.ceil(
        this.filteredDifficultyLevels.length /
          this.pageSize
      )
    );

    if (this.page > lastAvailablePage) {
      this.page = lastAvailablePage;
    }
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.page = 1;

    this.applyFilters();
  }

  addDifficultyLevel(): void {
    this.router.navigate([
      '/admin/course-reference/add-difficulty-level'
    ]);
  }

  editDifficultyLevel(
    difficultyLevel: DifficultyLevelItem
  ): void {
    this.router.navigate([
      '/admin/course-reference/difficulty-level/edit',
      difficultyLevel.id
    ]);
  }

  deleteDifficultyLevel(
    difficultyLevel: DifficultyLevelItem
  ): void {
    console.log(
      'Delete difficulty level:',
      difficultyLevel
    );
  }

  trackByDifficultyLevelId(
    _index: number,
    difficultyLevel: DifficultyLevelItem
  ): number {
    return difficultyLevel.id;
  }
}
